import { render, staticRenderFns } from "./tabInternalProjectBeneficiary.vue?vue&type=template&id=0575cf1e&"
import script from "./tabInternalProjectBeneficiary.vue?vue&type=script&lang=ts&"
export * from "./tabInternalProjectBeneficiary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports